import { render, staticRenderFns } from "./MeetingView.vue?vue&type=template&id=53b4945c&scoped=true&"
import script from "./MeetingView.vue?vue&type=script&lang=js&"
export * from "./MeetingView.vue?vue&type=script&lang=js&"
import style0 from "./MeetingView.vue?vue&type=style&index=0&id=53b4945c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4945c",
  null
  
)

export default component.exports